import moment from "moment";

export default function handleFormatDate(date: string) {
    const dateFormatted = moment(date).format('YYYY-MM-DD');

    return dateFormatted;
  }